import {scroller} from 'react-scroll';
import useMount from './useMount';

interface IProps {
    hashPrefix?: string;
    offset?: number;
    delay?: number;
}

export const useAutoScrollByUrlHash = ({hashPrefix = '', offset = 0, delay = 0}: IProps) => {
    useMount(() => {
        if (window?.location?.hash) {
            const name = `${hashPrefix}${window.location.hash.replace('#', '')}`;
            scroller.scrollTo(name, {delay, offset, smooth: true});
        }
    });
};
